import React from 'react';
import { classes } from 'utils';
import PaymentsReceived from './payments_received';
import PaymentsMade from './payments_made';


const PAYMENTS = {
  RECIEVED: 1,
  MADE: 2,
}

const ReportPayments = () => {
  const [payment, setPayment] = React.useState(PAYMENTS.RECIEVED);

  const handleChange = () => {
    setPayment(prev => prev === PAYMENTS.RECIEVED ? PAYMENTS.MADE : PAYMENTS.RECIEVED);
  }


  return (
    <div id="payments">
      <div className='filter-tabs'>
        <Tab
          label="Pagos recibidos"
          onChange={handleChange}
          isActive={payment === PAYMENTS.RECIEVED}
        />
        <Tab
          label="Pagos realizados"
          onChange={handleChange}
          isActive={payment === PAYMENTS.MADE}
        />
      </div>


      {payment === PAYMENTS.RECIEVED && <PaymentsReceived />}
      {payment === PAYMENTS.MADE && <PaymentsMade />}
    </div>
  )
}


interface TabProps {
  label: string;
  onChange: () => void;
  isActive: boolean;
}

const Tab = ({ label, onChange, isActive }: TabProps) => {
  return (
    <div className={classes('filter-tab', isActive && 'active')} onClick={onChange}>
      <span>{label}</span>
    </div>
  );
}

export default ReportPayments;